import type { PrimaryThemeColor } from '../../config/theme';
import { createStoreWithSelector } from '../../utils/zustand/createStoreWithSelector';
import { createUseStore } from '../../utils/zustand/createUseStore';
import { WithReset } from '../../utils/zustand/zustandTypes';

type State = {
  selectedThemeColor: PrimaryThemeColor | null;
};

type Actions = {
  setThemeColor: (themeColor: PrimaryThemeColor | null) => void;
  reset: () => void;
};

const initialData: State = {
  selectedThemeColor: null
};

export const themeContext = createStoreWithSelector<WithReset<State & Actions>>()((set) => ({
  ...initialData,
  setThemeColor: (themeColor) => set({ selectedThemeColor: themeColor }),
  reset: () => set(initialData)
}));

export const useThemeContext = createUseStore(themeContext);
